<template>
  <div ref="mainContainerLandingHeroLite">
    <!-- {{ width }} -->
    <Container
      bounds-inner-styles="margin-top: -1rem; padding-top: 0rem; padding-bottom: 0rem;"
      :bounds-styles="
        !isStandalone
          ? 'padding-right: 0px; padding-left: 0px; max-width: unset;'
          : 'padding-right: 15px; padding-left: 15px;'
      "
    >
      <div class="hero" :class="{ 'is-dark': dark }">
        <b-row :class="getHeroContainer()" :style="heroContainerStyles">
          <b-col cols="12" md="6" class="hero-content">
            <h3 class="pb-20" style="size: 40px; line-height: 48px;" v-html="hero.title"></h3>

            <p
              class="subline pb-30"
              style="size: 18px; line-height: 32px; margin-top: -1.5rem; margin-bottom: 1rem;"
              v-html="hero.subtitle"
            ></p>

            <div v-if="hero.list" class="hero-list">
              <div v-for="item in hero.list" :key="item.id" class="hero-list-item">
                <i class="icon-checkmark fs13 text-blue-900 pr-10"></i>
                <p v-html="item.text"></p>
              </div>
            </div>

            <!-- <p class="price pt-20">{{ hero.price }}</p>
            <p class="terms pb-40">{{ hero.terms }}</p> -->

            <router-link
              v-if="!hero.button.isExternal"
              :to="hero.button.link"
              class="btn btn-lg"
              :class="{ 'btn-green': dark }"
              :target="hero.button.newTab ? '_blank' : '_self'"
              >{{ hero.button.label }}</router-link
            >
            <a
              v-else
              :href="hero.button.link"
              class="btn btn-lg"
              :class="{ 'btn-green': dark }"
              target="_blank"
            >
              {{ hero.button.label }}
            </a>
            <p class="note pt-10">{{ hero.caption }}</p>
          </b-col>

          <b-col cols="6" :class="getClass('hero-pattern', 767) + ' ' + getHeroPatternMDMixin()">
            <img
              v-if="hero.customPattern"
              :src="hero.customPattern"
              class="custom-pattern"
              alt="pattern"
            />
            <PatternSvg v-else :class="getClass('pattern', 991)" />
            <img :src="hero.image" alt="man" :class="getClass('man', 991)" />
          </b-col>
        </b-row>
      </div>
    </Container>
  </div>
</template>

<script>
import PatternSvg from '@/assets/components/funding/pattern_small.svg?inline';
import Container from '@/components/Container';

export default {
  name: 'LandingHero',
  components: {
    Container,
    PatternSvg
  },
  props: {
    hero: {
      type: Object,
      required: true
    },
    dark: Boolean,
    hasPanel: {
      type: Boolean
    },
    photoStyles: {
      type: String,
      required: false
    },
    heroContainerStyles: {
      type: String,
      required: false
    },
    isStandalone: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mounted() {},
  methods: {
    getClass(cls, minWidth) {
      if (this.width < minWidth) {
        return `${cls}_thin`;
      } else {
        return `${cls}`;
      }
    },
    getHeroContainer() {
      if (this.width > 1199) {
        return 'hero-container';
      } else {
        if (this.width > 767) {
          return 'hero-container_md';
        } else {
          if (this.width > 543) {
            return 'hero-container_sm';
          } else {
            return 'hero-container_sm';
            // return 'hero-container_xs'
          }
        }
      }
    },
    getHeroPatternMDMixin() {
      if (this.width > 991 && this.width < 1199) {
        return 'hero-patter_md_mixin';
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hero {
  padding-top: rem(20px);
  padding-bottom: rem(40px);

  &.is-dark {
    color: $white;

    .hero-container {
      background-color: #363b49;
    }

    .hero-content {
      .note {
        color: $baltic-blue;
      }
    }

    .hero-pattern {
      .pattern {
        /deep/ .lines {
          fill: #28cf94;
        }
      }
    }
  }

  .hero-container {
    max-width: 1360px !important;
    margin: 0 auto;
    background-color: $blue-200;
    height: rem(360px);
    padding: rem(50px) !important;
    // overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    @include media-breakpoint-up(xl) {
      max-width: 1360px !important;
    }

    // @include media-breakpoint-down(md) {
    //   padding-left: rem(15px) !important;
    //   padding-right: rem(15px) !important;
    // }

    // @include media-breakpoint-down(sm) {
    //   height: auto;
    // }

    // @include media-breakpoint-down(xs) {
    //   .col-12 {
    //     padding: 0;
    //   }
    // }
  }
  .hero-container_md {
    margin: 0 auto;
    background-color: $blue-200;
    height: rem(360px);
    padding-top: rem(50px) !important;
    padding-bottom: rem(50px) !important;
    // overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    padding-left: rem(15px) !important;
    padding-right: rem(15px) !important;
  }

  .hero-container_sm {
    margin: 0 auto;
    background-color: $blue-200;
    padding-top: rem(50px) !important;
    padding-bottom: rem(50px) !important;
    // overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;

    padding-left: rem(15px) !important;
    padding-right: rem(15px) !important;

    height: auto;
    .col-md-6 {
      max-width: 100% !important;
      flex: unset !important;
    }
  }

  .hero-container_xs {
    margin: 0 auto;
    background-color: $blue-200;
    padding-top: rem(50px) !important;
    padding-bottom: rem(50px) !important;
    // overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    padding-left: rem(15px) !important;
    padding-right: rem(15px) !important;
    height: auto;
    .col-md-6 {
      max-width: 100% !important;
    }
    .col-12 {
      padding: 0;
    }
  }

  .hero-content {
    position: relative;
    z-index: 2;
    max-width: 520px;

    .subline {
      font-size: 1.1rem;
    }

    .note {
      font-size: 0.8rem;
      color: $gray-600;
    }

    .price {
      font-size: rem(40px);
      color: $dark-blue;
      font-weight: 800;
    }

    .terms {
      font-size: rem(14px);
      color: $gray-600;
    }

    .hero-list {
      max-width: rem(554px);
      .hero-list-item {
        display: inline-flex;
        align-items: baseline;
        padding-bottom: rem(20px);

        p {
          color: $ash-blue;
          font-size: rem(22px);
        }
      }
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  .hero-pattern {
    height: 100%;
    position: relative;
    flex: 0 0 auto;
    margin-right: -1.575rem;

    .pattern {
      position: absolute;
      right: -1.5rem;
      top: -2.5rem;
      width: 510px;
      height: 340px;
      object-fit: cover;
      object-position: 100% 0%;
    }

    .pattern_thin {
      position: absolute;
      right: 1rem;
      top: -2.5rem;
      width: 350px;
      height: 340px;
      object-fit: cover;
      object-position: 200% 0%;
    }

    .man {
      position: absolute;

      width: 460px;
      height: 380px;
      object-fit: cover;
      object-position: 100% 0%;
      right: 0;
      bottom: -3.1rem;
    }
    .man_thin {
      position: absolute;
      width: 300px;
      height: 380px;
      object-fit: cover;
      object-position: 100% 0%;
      left: 0;
      bottom: -3.1rem;
    }
  }
  .hero-pattern_thin {
    display: none;
  }

  .hero-patter_md_mixin {
    margin-right: unset !important;
    right: 1rem !important;
  }
}
</style>
